interface TextWithHighlightsProps {
  text: string;
  highlightedStrings: string[]; // Note: passed to regexp as-is.
  highlightClassName: string;
}

/**
 * Highlight instances of specific strings by enclosing them in 'mark' tags.
 */
export function TextWithHighlights({
  text = "",
  highlightedStrings = [],
  highlightClassName = "",
}: TextWithHighlightsProps) {
  if (highlightedStrings.length === 0) {
    return <span>{text}</span>;
  }
  // Note that the regex must have a capture group so that the matches show up in the results of split().
  const highlightRe = new RegExp(`(${highlightedStrings.join("|")})`, "gi");
  const parts = text.split(highlightRe);
  return (
    <span>
      {parts.map((part, i) =>
        highlightRe.test(part) ? (
          <mark className={highlightClassName} key={i}>
            {part}
          </mark>
        ) : (
          <span key={i}>{part}</span>
        ),
      )}
    </span>
  );
}
